import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface WizardNavigationProps {
  onBack?: (() => void) | undefined;
  onNext?: (() => void) | undefined;
  nextLabel?: string | undefined;
  nextDisabled?: boolean | undefined;
}

export function WizardNavigation({
  onBack,
  onNext,
  nextLabel = 'Next',
  nextDisabled = false,
}: WizardNavigationProps) {
  return (
    <div className="flex items-center justify-between border-t pt-6 mt-6">
      <div>
        {onBack !== undefined && (
          <Button variant="outline" type="button" onClick={onBack}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
        )}
      </div>

      <div>
        {onNext !== undefined && (
          <Button type="button" onClick={onNext} disabled={nextDisabled}>
            {nextLabel}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
